import { useContext } from "react"
import { AppContext } from "../App"
import { MdHome, MdLogout, MdMenu, MdNotifications, MdOutlineMessage, MdOutlineNotifications } from "react-icons/md";
import { IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots, TbReportAnalytics } from "react-icons/tb";
import { callApi, setCookie } from "../Helpers";
import { AiOutlineAppstore, AiOutlineDashboard, AiOutlineMenu, AiOutlineMessage, AiOutlineUser } from 'react-icons/ai';
import { STR_ACCOUNT, STR_CONTACTS, STR_LEARN, STR_MENU_DATING, STR_MENU_DOCTORS, STR_MENU_HOME, STR_MENU_INBOX, STR_MESSAGES, STR_TAB_ACCOUNT, STR_TAB_MENU, STR_TAB_MY_BUSINESSES, STR_TRACK } from "../Strings";
import { RiContactsBookLine, RiHome6Fill, RiHomeLine } from 'react-icons/ri';
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { LiaSchoolSolid } from "react-icons/lia";
import { CgProfile } from "react-icons/cg";
import { GrBusinessService, GrUserSettings } from "react-icons/gr";
import { LuClipboardList } from "react-icons/lu";


export default function BottomBar(props) {

  const appContext = useContext(AppContext);

  return (
    <div
      className="BottomBar"
      style={{
        display: "none",
      }}
    >
      <div className="d-flex justify-content-between" style={{ height: "100%" }}>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'main-menu' || !appContext.navItem}
          onClick={() => {
            appContext.navTo({
              item: 'main-menu',
            })
          }}
        >
          <AiOutlineAppstore className="mSymbol" />
          <h6 className="mText">{STR_TAB_MENU[appContext.language]}</h6>
        </div>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'my-businesses'}
          onClick={() => {
            appContext.navTo({
              item: 'my-businesses',
            })
          }}
        >
          <LuClipboardList className="mSymbol" />
          <h6 className="mText">{STR_TAB_MY_BUSINESSES[appContext.language]}</h6>
        </div>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'account'}
          onClick={() => {
            appContext.navTo({
              item: 'account',
            })
          }}
        >
          <AiOutlineUser className="mSymbol" />
          <h6 className="mText">{STR_TAB_ACCOUNT[appContext.language]}</h6>
        </div>



      </div>
    </div>
  )
}